import React from "react";
import { motion } from "framer-motion";

const SkeletonPhoto = ({ size = "normal" }) => {
  const sizeClasses = {
    normal: "col-span-1 row-span-1",
    wide: "col-span-2 row-span-1",
    tall: "col-span-1 row-span-2",
    large: "col-span-2 row-span-2",
  };

  return (
    <motion.div
      className={`${sizeClasses[size]} relative overflow-hidden bg-gray-200 rounded-lg`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {/* Efecto shimmer animado */}
      <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite]">
        <div className="h-full w-full bg-gradient-to-r from-transparent via-white/40 to-transparent" />
      </div>

      {/* Contenido del skeleton */}
      <div className="absolute inset-0 p-3 flex flex-col justify-end">
        {/* Simulación de avatar y nombre */}
        <div className="flex items-center gap-2 mb-2">
          <div className="w-6 h-6 rounded-full bg-gray-300 animate-pulse" />
          <div className="h-3 w-20 bg-gray-300 rounded animate-pulse" />
        </div>

        {/* Simulación de iconos de acciones */}
        <div className="flex gap-3">
          <div className="h-4 w-8 bg-gray-300 rounded animate-pulse" />
          <div className="h-4 w-8 bg-gray-300 rounded animate-pulse" />
        </div>
      </div>
    </motion.div>
  );
};

export default SkeletonPhoto;
